/* eslint-disable no-constant-condition */
import fetchHelper from 'library/FetchHelper'
import { API_ASDI_CMS_BASE_URL } from 'config/constants'
import * as qs from 'query-string'
import { setGetNameSevice } from './setGetNameService'

export function setGetProfileUser(cbs?: any, cbe?: any) {
  try {
    fetchHelper
      .fetch(`${API_ASDI_CMS_BASE_URL}/profile`, {
        method: 'GET',
      })
      .then(([resp, status]: any) => {
        if (status === 200) {
          if (cbs) cbs(resp.data)
        } else if (cbe) cbe(resp)
      })
  } catch (error) {
    console.error('setGetProfileUser', error)
  }

  return null
}

export async function setGetProfileUserAddress(payload?: string, cbs?: any, cbe?: any) {
  try {
    fetchHelper
      .fetch(`${API_ASDI_CMS_BASE_URL}/profile/${payload}`, {
        method: 'GET',
      })
      .then(async ([resp, status]: any) => {
        if (status === 200) {
          const dataInfo = {
            ...resp.data,
            nameSevice: await setGetNameSevice(resp.data.walletAddress),
          }

          if (cbs) cbs(dataInfo)
        } else if (cbe) cbe(resp)
      })
  } catch (error) {
    console.error('setGetProfileUserAddress', error)
  }

  return null
}

export async function getCoingeckoSimplePrice(payload: any, cbs?: any) {
  try {
    const qStr = qs.stringify(payload)
    fetchHelper
      .fetch(`https://api.coingecko.com/api/v3/simple/price?${qStr}`, {
        method: 'GET',
      })
      .then(([resp, status]: any) => {
        if (cbs) cbs(resp)
        return resp
      })
  } catch (error) {
    console.error('setGetListCollection', error)
  }

  return null
}
